import {
  Home,
  GraduationCap,
  BookOpen,
  MessageSquare,
  BarChart3,
} from 'lucide-react';
import { NavLink } from 'react-router-dom';

import { cn } from '@/lib/utils';

const navItems = [
  { to: '/', icon: Home, label: 'Home', end: true },
  { to: '/training', icon: GraduationCap, label: 'Training', end: false },
  { to: '/guides', icon: BookOpen, label: 'Guides', end: false },
  { to: '/check-ins', icon: MessageSquare, label: 'Check-ins', end: false },
  { to: '/progress', icon: BarChart3, label: 'Progress', end: false },
];

export function Sidebar() {
  return (
    <aside className="hidden w-64 shrink-0 border-r bg-card lg:block">
      <div className="flex h-full flex-col">
        <div className="flex items-center gap-3 border-b px-4 py-4">
          <img src="/logo.png" alt="Metaonia" className="h-10 w-10 object-contain" />
          <div className="flex flex-col">
            <span className="text-sm font-bold text-primary">Metaonia</span>
            <span className="text-xs text-muted-foreground">Manager Portal</span>
          </div>
        </div>
        <nav className="flex-1 space-y-1 p-4">
          {navItems.map(({ to, icon: Icon, label, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              className={({ isActive }) =>
                cn(
                  'flex items-center gap-3 rounded-md px-3 py-2 text-sm font-medium transition-colors',
                  isActive
                    ? 'bg-primary/10 text-primary'
                    : 'text-muted-foreground hover:bg-accent hover:text-accent-foreground',
                )
              }
            >
              <Icon className="h-5 w-5" />
              {label}
            </NavLink>
          ))}
        </nav>
      </div>
    </aside>
  );
}

export { navItems };
